import { skipToken } from "@reduxjs/toolkit/query";
import {
  ProgramType,
  type PlanResponse,
  type Program,
} from "../state/api.types";
import { api } from "../state/api";

export function useBatteryProgram(plan: PlanResponse): Program | undefined {
  const battery_program_uuid = plan.linked_programs.find(
    (program) => program.program_type === ProgramType.Battery,
  )?.uuid;
  return api.useGetProgramQuery(battery_program_uuid ?? skipToken).data;
}

export function useEvChargingProgram(plan: PlanResponse): Program | undefined {
  const ev_charging_program_uuid = plan.linked_programs.find(
    (program) => program.program_type === ProgramType.Evcharging,
  )?.uuid;
  return api.useGetProgramQuery(ev_charging_program_uuid ?? skipToken).data;
}
